import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=04db1237&"
import script from "./pool.vue?vue&type=script&lang=js&"
export * from "./pool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports